import { SubAPI } from "./SubAPI";
export class QuoteAlternatives extends SubAPI {
    getDefault(input) { return this.fetcher.post("/api/quote-alternative/default", input); }
    upsert(input) { return this.fetcher.post("/api/quote-alternative/upsert", input); }
    create(input) { return this.fetcher.post("/api/quote-alternative/create", input); }
    list(input) { return this.fetcher.get("/api/quote-alternatives", input); }
}
export function formatAlternativeNumber(alternativeNumber) { return "A" + alternativeNumber; }
export function alternativeLabel(alt) { return `${formatAlternativeNumber(alt.alternativeNumber)} - ${alt.name}`; }
